import {
  Box,
  Grid,
  Typography,
  Theme,
} from '@mui/material';
import { useState } from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { selectMemberInformation } from '../../../../store/slices/onboardingSlice';
import { useAppSelector } from '../../../../store/hooks';
import {
  EditOption, ErrorAlert, IFormInputs, StyledTextField,
} from '../../../../common/StyledFormInputs';
import { Body8VariantTypography } from '../../../../common/TypographyVariants';
import { TestIds } from '../../../../assets/testIds';

export function MemberInformationFormControl({ hasEmptyFields = false, isProfileForm = false }) {
  const { t } = useTranslation();
  const memberInfo = useAppSelector(selectMemberInformation);
  const [editMemberName, setEditMemberName] = useState(hasEmptyFields);
  const { register, formState: { errors } } = useFormContext<IFormInputs>();

  return (
    <>
      {!isProfileForm &&
        <>  <Typography variant="h2" gutterBottom>
          {t('hdSupply.memberInformation.heading')}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={8} sm={10} md={10} lg={10}>
            <Body8VariantTypography>{t('hdSupply.memberInformation.name') || ''}</Body8VariantTypography>
          </Grid>
          {!editMemberName &&
              <Grid item xs={4} sm={2} md={2} lg={2}>
                <EditOption updateEditState={(newState: boolean) => setEditMemberName(newState)} />
              </Grid>
          }
        </Grid>
        </>
      }
      {editMemberName ? <Box>
        <Box sx={(theme: Theme) => ({ mb: theme.spacing(1) })}>
          <Body8VariantTypography>{`${t('onboarding.questionPlaceholder.First Name')}*` || ''}</Body8VariantTypography>
          <StyledTextField
            data-testid={TestIds.rewardsPage.signUpForm.firstNameTxt}
            placeholder='First Name'
            {...register('memberInfo.firstName', { required: true })}
          />
          {(errors.memberInfo?.firstName) && <ErrorAlert />}
        </Box>
        <Box sx={(theme: Theme) => ({ mb: theme.spacing(1) })}>
          <Body8VariantTypography>{`${t('onboarding.questionPlaceholder.Last Name')}*` || ''}</Body8VariantTypography>
          <StyledTextField
            data-testid={TestIds.rewardsPage.signUpForm.lastNameTxt}
            placeholder='Last Name'
            {...register('memberInfo.lastName', { required: true })}
          />
          {(errors.memberInfo?.lastName) && <ErrorAlert />}
        </Box>
      </Box> : <Box>
        <Typography variant='body4' data-testid={TestIds.rewardsPage.signUpForm.fullnameLbl}> {memberInfo.firstName}  {memberInfo.lastName}</Typography>
      </Box>}</>
  );
}
